/**
 * Build admin Five S classification rule cards from persisted config.
 * Kept pure so UI copy can be unit-tested without mounting the page.
 */

const FAMILY_META = {
  isolated: { label: 'ISOLATED', color: 'emerald' },
  structural: { label: 'STRUCTURAL', color: 'orange' },
  recovery: { label: 'RECOVERY', color: 'blue' },
  structural_recovery: { label: 'STRUCTURAL + RECOVERY', color: 'purple' },
  data_breach: { label: 'DATA BREACH METHOD', color: 'red' },
};

export function buildClassificationCardsFromConfig(config) {
  if (!config) return [];
  const isolated = config.isolated || {};
  const structural = config.structural || {};
  const recovery = config.recovery || {};
  const combo = config.structural_recovery || {};
  const breach = config.data_breach || {};
  return [
    {
      classification: 'isolated',
      ...FAMILY_META.isolated,
      rules: [
        `${isolated.min_late_payments ?? 1}–${isolated.max_late_payments ?? 2} verified late payments only`,
        isolated.exclude_charge_off ? 'No charge-offs' : 'Charge-offs allowed',
        isolated.exclude_collection
          ? 'No collections (true collection agency / placed-for-collection stays Recovery)'
          : 'Collections allowed',
        isolated.exclude_repossession ? 'No repossessions' : 'Repossessions allowed',
        isolated.exclude_bankruptcy ? 'No bankruptcies' : 'Bankruptcies allowed',
        isolated.exclude_eviction ? 'No evictions' : 'Evictions allowed',
        'Missing payment history cannot create isolated eligibility',
      ],
      threshold: `${isolated.min_late_payments ?? '—'}–${isolated.max_late_payments ?? '—'} verified late months only`,
    },
    {
      classification: 'structural',
      ...FAMILY_META.structural,
      rules: [
        `${structural.min_late_payments ?? '—'}+ late payments`,
        structural.include_charge_off
          ? 'Charge-offs present (including single-bureau account-level ratings)'
          : 'Charge-offs excluded',
        structural.include_bankruptcy ? 'Bankruptcies present' : 'Bankruptcies excluded',
        structural.include_eviction ? 'Evictions present' : 'Evictions excluded',
        structural.include_repeated_delinquency ? 'Repeated delinquency pattern' : 'Repeated delinquency off',
      ],
      threshold: `${structural.min_late_payments ?? '—'}+ lates OR charge-off / structural flags`,
    },
    {
      classification: 'recovery',
      ...FAMILY_META.recovery,
      rules: [
        recovery.include_collection ? 'True collection agency / placed-for-collection' : 'Collections off',
        recovery.include_debt_buyer ? 'Debt buyers' : 'Debt buyers off',
        recovery.include_repossession ? 'Repossessions' : 'Repossessions off',
        recovery.include_surrender ? 'Surrender' : 'Surrender off',
        recovery.include_deficiency ? 'Deficiency balances' : 'Deficiency off',
        recovery.include_transferred_post_default ? 'Transferred/post-default debt' : 'Transferred post-default off',
      ],
      threshold: 'True collection/recovery predicates (not Metro2 Collection Or Charge Off rating alone)',
    },
    {
      classification: 'structural_recovery',
      ...FAMILY_META.structural_recovery,
      rules: [
        combo.combine_when_same_bureau
          ? 'Combine when same bureau has Structural + Recovery'
          : 'Same-bureau combo disabled',
        'Package-level only — items keep original family',
        'Never merge across bureaus',
      ],
      threshold: 'Same-bureau Structural + Recovery',
    },
    {
      classification: 'data_breach',
      ...FAMILY_META.data_breach,
      rules: [
        breach.user_selectable_only ? 'User-selectable or authorized only' : 'Selectable flag off',
        breach.auto_classify_accounts === false
          ? 'Never auto-classify normal accounts'
          : 'Account auto-classify enabled (invalid)',
        breach.authorize_inquiry_items ? 'Inquiry removal authorized path' : 'Inquiry path off',
        breach.authorize_personal_info_items ? 'PI deletion authorized path' : 'PI path off',
      ],
      threshold: 'User-selectable / authorized',
      isUserSelectable: true,
      note: 'Does not auto-classify normal negative accounts to Data Breach.',
    },
  ];
}
